import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./protectedRoute";
import ScrollToTop from "./components/ScrollToTop";

// Import des pages
import Login from "./pages/connections/login/login";
import Register from "./pages/connections/register/register";
import ForgotPassword from "./pages/connections/password/ForgotPassword";
import ResetPassword from "./pages/connections/password/ResetPassword";
import Accueil from "./pages/acceuil/acceuil";
import IndexPosts from "./pages/posts/indexPosts";
import ShowPost from "./pages/posts/show";
import Profile from "./pages/users/profile";
import Contact from "./pages/contact/contactForm";
import Galerie from "./pages/galerie/galerie";
import EditUser from "./pages/users/editUser";
import EditPassword from "./pages/users/editPassword";
import EmailVerified from "./pages/connections/verification/EmailVerified";
import RegisterPendingVerification from "./pages/connections/verification/RegisterPendingVerification";
import Cgu from "./pages/connections/confidentialite/CGU";
import Confidentialite from "./pages/connections/confidentialite/politiqueConfidentialite";
import NewsletterForm from "./pages/NewsLetter/NewsLetterForm";
import ChatForm from "./components/chat/ChatForm";
import VerifyEmail from "./pages/connections/verification/VerifyEmail";

// Import du Header
import Header from "./templates/header";

// Import du footer
import Footer from "./templates/footer";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />

        <div className="App min-h-screen bg-gray-900 flex flex-col">
          <Header />

          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Accueil />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/cgu" element={<Cgu />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/NewsLetter" element={<NewsletterForm />} />
              <Route path="/posts" element={<IndexPosts />} />
              <Route path="/posts/:slug" element={<ShowPost />} />
              <Route path="/email-verified" element={<EmailVerified />} />

              <Route
                path="/register-pending-verification"
                element={<RegisterPendingVerification />}
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contact"
                element={
                  <ProtectedRoute>
                    <Contact />
                  </ProtectedRoute>
                }
              />
              <Route path="/galerie" element={<Galerie />} />
              <Route
                path="/user/edit/:id"
                element={
                  <ProtectedRoute>
                    <EditUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/editPassword/:id"
                element={
                  <ProtectedRoute>
                    <EditPassword />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>

          <Footer />

          <ChatForm />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
